/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SendOtpBody } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { ValidateOtpBody } from '../models';
// @ts-ignore
import type { ValidateOtpResponse } from '../models';
/**
 * SmsApiApi - axios parameter creator
 */
export const SmsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SendOtpBody} sendOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsApiGenerateSms: async (sendOtpBody: SendOtpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendOtpBody' is not null or undefined
            assertParamExists('smsApiGenerateSms', 'sendOtpBody', sendOtpBody)
            const localVarPath = `/sms/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOtpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateOtpBody} validateOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsApiValidateOtp: async (validateOtpBody: ValidateOtpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateOtpBody' is not null or undefined
            assertParamExists('smsApiValidateOtp', 'validateOtpBody', validateOtpBody)
            const localVarPath = `/sms/validate_otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateOtpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmsApiApi - functional programming interface
 */
export const SmsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SmsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SendOtpBody} sendOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smsApiGenerateSms(sendOtpBody: SendOtpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smsApiGenerateSms(sendOtpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SmsApiApi.smsApiGenerateSms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidateOtpBody} validateOtpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smsApiValidateOtp(validateOtpBody: ValidateOtpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smsApiValidateOtp(validateOtpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SmsApiApi.smsApiValidateOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SmsApiApi - factory interface
 */
export const SmsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SmsApiApiFp(configuration)
    return {
        /**
         * 
         * @param {SmsApiApiSmsApiGenerateSmsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsApiGenerateSms(requestParameters: SmsApiApiSmsApiGenerateSmsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.smsApiGenerateSms(requestParameters.sendOtpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SmsApiApiSmsApiValidateOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsApiValidateOtp(requestParameters: SmsApiApiSmsApiValidateOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateOtpResponse> {
            return localVarFp.smsApiValidateOtp(requestParameters.validateOtpBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for smsApiGenerateSms operation in SmsApiApi.
 */
export interface SmsApiApiSmsApiGenerateSmsRequest {
    readonly sendOtpBody: SendOtpBody
}

/**
 * Request parameters for smsApiValidateOtp operation in SmsApiApi.
 */
export interface SmsApiApiSmsApiValidateOtpRequest {
    readonly validateOtpBody: ValidateOtpBody
}

/**
 * SmsApiApi - object-oriented interface
 */
export class SmsApiApi extends BaseAPI {
    /**
     * 
     * @param {SmsApiApiSmsApiGenerateSmsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public smsApiGenerateSms(requestParameters: SmsApiApiSmsApiGenerateSmsRequest, options?: RawAxiosRequestConfig) {
        return SmsApiApiFp(this.configuration).smsApiGenerateSms(requestParameters.sendOtpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SmsApiApiSmsApiValidateOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public smsApiValidateOtp(requestParameters: SmsApiApiSmsApiValidateOtpRequest, options?: RawAxiosRequestConfig) {
        return SmsApiApiFp(this.configuration).smsApiValidateOtp(requestParameters.validateOtpBody, options).then((request) => request(this.axios, this.basePath));
    }
}

